type Listener = () => void;

export abstract class BaseStore<TState> {
  private listeners = new Set<Listener>();
  private state: TState | null = null;
  private stateKey: string | null = null;

  protected abstract createState(): TState;
  protected abstract getStateKey(): string;

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  getState = (): TState => {
    const currentKey = this.getStateKey();
    
    if (this.state === null || this.stateKey !== currentKey) {
      this.state = this.createState();
      this.stateKey = currentKey;
    }
    
    return this.state;
  };

  protected notifyListeners = (): void => {
    this.state = null;
    this.stateKey = null;
    
    this.listeners.forEach((listener) => {
      listener();
    });
  };
}

